import { Injectable } from '@angular/core';
import { Order } from '../_model/order.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DictionaryService } from 'src/app/dictionary/dictionary.service';


const url = environment.api;


@Injectable({
  providedIn: 'root'
})
export class OrderService {

  order: Order;
  orders: Order[] = [];

  constructor(private http: HttpClient) {
  }

  getOrders() {
    return this.http.get<Order[]>(url + 'order?order=desc');
  }

  getOrder(idOrder: number) {
    return this.http.get<Order>(url + 'order/' + idOrder);
  }


  getOrdersByIdCompanyProvider(companyId: number) {
    return this.http.get<Order[]>(url + 'order?order=desc&idCompanyProvider=' + companyId);
  }

  getOrdersByIdUser(userId: number) {
    return this.http.get<Order[]>(url + 'order?order=desc&idUser=' + userId);
  }

  createOrder() {
    return this.http.post<Order>(url + 'order', this.order);
  }

  updateOrder(idOrder: number, data: Order) {
    return this.http.put<Order>(url + 'order/' + idOrder, data);
  }

  findOrder(orderId: number) {
    if (this.orders.length === 0) {
      this.getOrders().subscribe((orders: Order[]) => {
        this.orders = orders;
        this.order = this.orders.find(a => a.id === orderId);
      }
      );
    } else {
      this.order = this.orders.find(a => a.id === orderId);

    }
  }

}
